"use client";

import Script from "next/script";
import { isRecaptchaEnabled } from "@/lib/recaptcha";

interface RecaptchaScriptProps {
  siteKey: string | undefined;
}

export default function RecaptchaScript({ siteKey }: RecaptchaScriptProps) {
  if (!isRecaptchaEnabled() || !siteKey) {
    return null;
  }

  return (
    <Script
      id="recaptcha-enterprise"
      src={`https://www.google.com/recaptcha/enterprise.js?render=${encodeURIComponent(siteKey)}`}
      strategy="afterInteractive"
    />
  );
}
